import { computed, inject, Injectable, signal } from '@angular/core';
import { DataService } from '../data/data.service';
import { environment } from 'src/environments/environment';
import { RequestParam } from 'src/app/interfaces/requestParam';
import { StoreService } from '../store/store.service';
import { CookiesService } from '../cookies/cookies.service';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SupportService {
  private dataService = inject(DataService);
  private cookiesService = inject(CookiesService);
  public defaultForm = new supportElements();
  private supportApiUrl = `${environment.supportApiUrl}`;
  private hubspotFormSuffix = `${this.supportApiUrl}/hubspot`;
  private hubspotPortalId = '22207066';

  readonly SignUpFormId = signal('72381ffa-8c18-4a18-a7b5-0e04cbce2a71');
  readonly formUrl = computed(() => `${this.hubspotFormSuffix}/${this.SignUpFormId()}`);
  private store = inject(StoreService);

  constructor() {
  }

  getHubspotForms() {
    let option: RequestParam = {
      url: `${this.hubspotFormSuffix}/forms/`,
      apiName: 'getHubspotForms'
    }
    return this.dataService.get(option);
  }

  submitHubspotForm(formData: any) {
    const headers = new Map();
    headers.set('skip', 'true');

    const option: RequestParam = {
      url: `${this.hubspotFormSuffix}/form/submission/${this.hubspotPortalId}/${this.SignUpFormId()}`,
      data: formData,
      // params: { productType: this.store.getProduct() },
      headers: Object.fromEntries(headers),
    }
    return this.dataService.post(option)
  }

  /**
   * Gets the HubSpot tracking cookie (hubspotutk) from the browser
   * @returns The hubspotutk cookie value or empty string if not found
   */
  private getHubspotTrackingCookie(): string {
    // Use CookiesService to get the hubspotutk cookie
    return this.cookiesService.get('hubspotutk') || '';
  }

  mapToFields(api: ApiResponse, formData: any): { fields: OutField[], context: { hutk?: string, pageName: string, pageUri?: string } } {
    const outputFields: OutField[] = [];
    const allFields = formData.fieldGroups.flatMap((group: any) => group.fields);

    // Get the HubSpot tracking cookie
    const hubspotCookie = this.getHubspotTrackingCookie();

    allFields.forEach((field: any) => {
      const fieldName = field.name;
      const value = api[fieldName];

      // If value exists for the field in the API response, push to the output array
      if (Array.isArray(value)) {
        value.forEach((val) => {
          if (val !== undefined && val !== null && val !== '') {
            outputFields.push({
              objectTypeId: field.objectTypeId,
              name: `${field.objectTypeId}/${fieldName}`,
              value: val,
            });
          }
        });
      } else {
        // If the value is not an array, just push it as is
        if (value !== undefined && value !== null && value !== '') {
          outputFields.push({
            objectTypeId: field.objectTypeId,
            name: `${field.objectTypeId}/${fieldName}`,
            value: value,
          });
        }
      }
    });
    // Create context object with hutk and pageName
    const context: { hutk?: string, pageName: string, pageUri?: string } = {
      pageName: 'Account Creation'
    };
    
    // Add hutk to context if it exists
    if (hubspotCookie) {
      context.hutk = hubspotCookie;
    }
    
    return { 
      fields: outputFields,
      context: context
    };
  }

}

export class supportElements {

  mapObject:any = {
    "firstname": "firstname",
    "lastname": "lastname",
    "email": "email",
    "company": "company",
    "annualRevenue": "annualRevenue",
    "productSigningUpFor": "productSigningUpFor"
  }

  signupFormData = {
    "id": "72381ffa-8c18-4a18-a7b5-0e04cbce2a71",
    "name": "Create Account - API",
    "createdAt": "2025-06-19T04:18:11.639Z",
    "updatedAt": "2025-06-26T07:00:46.638Z",
    "archived": false,
    "fieldGroups": [
        {
            "groupType": "default_group",
            "richTextType": "text",
            "fields": [
                {
                    "objectTypeId": "0-1",
                    "name": "firstname",
                    "label": "First Name",
                    "required": false,
                    "hidden": false,
                    "fieldType": "single_line_text"
                },
                {
                    "objectTypeId": "0-1",
                    "name": "lastname",
                    "label": "Last Name",
                    "required": false,
                    "hidden": false,
                    "fieldType": "single_line_text"
                },
                {
                    "objectTypeId": "0-1",
                    "name": "email",
                    "label": "Email",
                    "required": true,
                    "hidden": false,
                    "validation": {
                        "blockedEmailDomains": [],
                        "useDefaultBlockList": false
                    },
                    "fieldType": "email"
                },
                {
                    "objectTypeId": "0-1",
                    "name": "company",
                    "label": "Company Name",
                    "required": false,
                    "hidden": false,
                    "fieldType": "single_line_text"
                },
                {
                    "objectTypeId": "0-1",
                    "name": "annualrevenue",
                    "label": "Annual Revenue",
                    "required": false,
                    "hidden": false,
                    "fieldType": "dropdown"
                },
                {
                    "objectTypeId": "0-1",
                    "name": "productsigningupfor",
                    "label": "Product Signing Up for",
                    "required": false,
                    "hidden": false,
                    "fieldType": "dropdown"
                }
            ]
        }
    ],
    "configuration": {
        "language": "en",
        "cloneable": true,
        "postSubmitAction": {
            "type": "thank_you",
            "value": ""
        },
        "editable": true,
        "archivable": true,
        "recaptchaEnabled": false,
        "notifyContactOwner": false,
        "notifyRecipients": [
            "24750240"
        ],
        "createNewContactForNewEmail": true,
        "prePopulateKnownValues": true,
        "allowLinkToResetKnownValues": false,
        "lifecycleStages": []
    },
    "displayOptions": {
        "renderRawHtml": false,
        "theme": "default_style",
        "submitButtonText": "",
        "style": {
            "fontFamily": "arial, helvetica, sans-serif",
            "backgroundWidth": "100%",
            "labelTextColor": "#33475b",
            "labelTextSize": "11px",
            "helpTextColor": "#7C98B6",
            "helpTextSize": "11px",
            "legalConsentTextColor": "#33475b",
            "legalConsentTextSize": "14px",
            "submitColor": "#ff7a59",
            "submitAlignment": "left",
            "submitFontColor": "#ffffff",
            "submitSize": "12px"
        },
        "cssClass": null
    },
    "legalConsentOptions": {
        "type": "none"
    },
    "formType": "hubspot"
}
}

interface ApiResponse {
  [key: string]: any;
}

interface OutField {
  objectTypeId: string;
  name: string;
  value: any;
  hutk?: string;
}